var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { TextField } from "@ane/ui-components/lib/components/FormikFormFields/TextField";
class SpecialColumnsField extends React.Component {
  render() {
    const { textFieldProps = {}, fieldName, required = true } = this.props;
    const { description = "Enter column name" } = textFieldProps;
    return /* @__PURE__ */ jsx(
      TextField,
      {
        name: fieldName,
        innerTextFieldProps: __spreadProps(__spreadValues({}, textFieldProps), {
          description,
          required,
          ariaLabel: `${this.props.ariaLabel}`
        })
      }
    );
  }
}
export {
  SpecialColumnsField
};
//# sourceMappingURL=SpecialColumnsField.js.map
